import { render } from "./nameLabel.vue?vue&type=template&id=0cce57e3&scoped=true"
import script from "./nameLabel.vue?vue&type=script&lang=js"
export * from "./nameLabel.vue?vue&type=script&lang=js"

import "./nameLabel.vue?vue&type=style&index=0&id=0cce57e3&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cce57e3"]])

export default __exports__